import React from 'react';

const Uganda1_primary_soc = () => {
  return (
    <div>
      
    </div>
  );
}

export default Uganda1_primary_soc;
